import { AgilityExportButtonComponent } from './agility-export-button.component';
import { ButtonModule } from 'primeng/button';
import { CommonModule, DecimalPipe } from '@angular/common';
import { MenuModule } from 'primeng/menu';
import { NgModule } from '@angular/core';
import { AgilityTableExportService } from '@agility-components/agility-table-export/services/agility-table-export.service';
import { AgilityTableDataAccessorService } from '@agility-components/agility-table/services/table-data-accessor/agility-table-data-accessor.service';

@NgModule({
  declarations: [AgilityExportButtonComponent],
  imports: [ButtonModule, CommonModule, MenuModule],
  exports: [AgilityExportButtonComponent],
  providers: [
    DecimalPipe,
    AgilityTableDataAccessorService,
    AgilityTableExportService,
  ],
})
export class AgilityExportButtonModule {}
